import { CategoryFirstLevel } from '@/shared/dtos/category-first-level';
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import offerDemandModule from '@/store/modules/offer-demand.module';
import DxDataGrid, { DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';
import categoryModule from '@/store/modules/category-first-level.module';
import { DxSelectBox } from 'devextreme-vue';





@Component({
    components: {
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxFilterRow,
        DxFilterPanel,
        DxExport,
        DxColumnChooser,
        DxSelectBox
    },
})

export default class InicioSearch extends Vue {

    private categoryIdSelect: number | null = null;
    private haveCategory: boolean = false;

    public async created() {
        await offerDemandModule.getOffersDemands();
        await categoryModule.getCategoriesAnonymous();
        if (offerDemandModule.categoryFirstLevelSelect !== null &&
            offerDemandModule.categoryFirstLevelSelect !== undefined &&
            offerDemandModule.categoryFirstLevelSelect.id > 0)
            this.haveCategory = true;
        else
            this.haveCategory = false;
    }


    public get columnsOfferDemand() {
        return [
            { dataField: 'name', caption: this.$tc('offers-demands.name') },
            { dataField: 'description', caption: this.$tc('offers-demands.description') },
            { dataField: 'amount', caption: this.$tc('offers-demands.amount')},
            { dataField: 'offer', caption: this.$tc('offers-demands.offer') },
            { dataField: 'demand', caption: this.$tc('offers-demands.demand') },

        ]
    }

    public get categoryFirstLevelList() {
        var categoriesFirstLevel: CategoryFirstLevel[] = [];
        var emptyCategory = new CategoryFirstLevel();
        emptyCategory.id = -1;
        categoriesFirstLevel.push(emptyCategory);

        categoriesFirstLevel = categoriesFirstLevel.concat(categoryModule.categories);

        return categoriesFirstLevel;
    }

    public async search() {
        if (this.categoryIdSelect && this.categoryIdSelect > 0) {
            this.haveCategory = true;
            offerDemandModule.actualizarCategorySelect(this.categoryIdSelect);
            await offerDemandModule.getOffersDemands();
        } else {
            this.haveCategory = false;
        }

    }

    public ofertaODemanda(value: boolean) {
        if(value) return this.$tc('offers-demands.offer');
        else return this.$tc('offers-demands.demand');
    }

    public photo(photo: any) {
        return photo;
    }

    public get offerDemandList() {
        return offerDemandModule.offerDemandList;
    }

    public get nameCategory() {
        return offerDemandModule.categoryFirstLevelSelect.code + ' - ' + offerDemandModule.categoryFirstLevelSelect.description;
    }
}